export const hasNoActiveHubs = (staff) =>
  !(staff.hubs?.some((h) => h.active === 1) ?? false);
